
<template>
  <div class="px-3">
    <div class="pl-3">Tipo de venda: </div>
    <v-radio-group v-model="order.kind" mandatory row color="red" class="pl-3">
      <v-radio value="pickup">
        <template v-slot:label>
          <div><strong class="success--text">Retira</strong></div>
        </template>
      </v-radio>
      <v-radio value="delivery" v-if="!order.is_default_client">
        <template v-slot:label>
          <div><strong class="primary--text">Entrega</strong></div>
        </template>
      </v-radio>
    </v-radio-group>
    <div v-if="order.kind == 'delivery'">
      <BuildingSelect ref="forms" :shipping="order.shipping_attributes" :client_id="order.client_id"></BuildingSelect>
    </div>
  </div>
</template>
<script>

export default {
  name: 'DeliveryKind',
  components: {
    AddressSelect:() => import("./AddressSelect.vue"),
    BuildingSelect:() => import("@/components/create_order/shared/BuildingSelect.vue"),
    AddressForm:() => import("@/_backoffice/_registrations/components/shared/forms/AddressForm.vue"),
  },
  props: {
    order: {
      type: Object,
      default: {}
    },
  },
  methods:{
    validate(){
      if(this.order.kind == 'delivery'){
        return this.$refs.forms.validate()
      }else{
        return true
      }
    }
  }
}
</script>